import React from 'react';
import { useIntl } from "react-intl";
import classNames from 'classnames';
import { useAgentSummary } from "@/query/deployment";
import { useAgentId } from "@/hook";
import IntentSummaryIcon from "@/assets/svgs/intent_summary.svg";
import EntitySummaryIcon from "@/assets/svgs/entity_summary.svg";
import VersionSummaryIcon from "@/assets/svgs/version_summary.svg";


const AgentSummary: React.FC = () => {
    const intl = useIntl();
    const agentId = useAgentId();

    const { data: summary, isPending } = useAgentSummary(agentId);

    if (isPending || !summary) {
        return null;
    }
    return (
        <div className="agent-summary">
            <div className="agent-summary-card">
                <div className="agent-summary-card-title">
                    <img src={IntentSummaryIcon} alt="move" className="size-8" />
                    {intl.formatMessage({ id: "i02003" })}
                </div>
                <div className="agent-summary-card-content-horizontal">
                    <div className="agent-summary-card-content-horizontal-section">
                        <div className="agent-summary-card-bold">
                            {summary.domain_info.intent_cnt.toLocaleString()}
                        </div>
                        <div className="agent-summary-card-normal">
                            {intl.formatMessage({ id: "i02022" })}
                        </div>
                    </div>

                    <div className="agent-summary-card-content-horizontal-divider" />

                    <div className="agent-summary-card-content-horizontal-section">
                        <div className="agent-summary-card-bold">
                            {summary.domain_info.sentence_cnt.toLocaleString()}
                        </div>
                        <div className="agent-summary-card-normal">
                            {intl.formatMessage({ id: "i02023" })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="agent-summary-card">
                <div className="agent-summary-card-title">
                    <img src={EntitySummaryIcon} alt="move" className="size-8" />
                    {intl.formatMessage({ id: "i02004" })}
                </div>
                <div className="agent-summary-card-content-horizontal">
                    <div className="agent-summary-card-content-horizontal-section">
                        <div className="agent-summary-card-bold">
                            {summary.domain_info.entity_cnt.toLocaleString()}
                        </div>
                        <div className="agent-summary-card-normal">
                            {intl.formatMessage({ id: "i02026" })}
                        </div>
                    </div>

                    <div className="agent-summary-card-content-horizontal-divider" />

                    <div className="agent-summary-card-content-horizontal-section">
                        <div className="agent-summary-card-bold">
                            {summary.domain_info.entity_value_cnt?.toLocaleString()}
                        </div>
                        <div className="agent-summary-card-normal">
                            {intl.formatMessage({ id: "i02027" })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="agent-summary-card !gap-y-4">
                <div className="agent-summary-card-title">
                    <div className="size-8 rounded-full bg-chat42-10 flex items-center justify-center">
                        <img src={VersionSummaryIcon} alt="move" className="size-4" />
                    </div>
                    {intl.formatMessage({ id: "i02005" })}
                </div>
                <div className="agent-summary-card-content-vertical">
                    <div className="agent-summary-card-content-vertical-section">
                        <div className={classNames("agent-summary-card-normal", intl.locale === "en" && "!w-32")}>
                            {intl.formatMessage({ id: "i02024" })}
                        </div>
                        <div className="agent-summary-card-bold">
                            {summary.sandbox_version.version ? (<>
                                <span className="text-[20px]">v</span>
                                {summary.sandbox_version.version}
                            </>) : "-"}
                        </div>
                    </div>
                    <div className="agent-summary-card-content-vertical-section">
                        <div className={classNames("agent-summary-card-normal", intl.locale === "en" && "!w-32")}>
                            {intl.formatMessage({ id: "i02025" })}
                        </div>
                        <div className="agent-summary-card-bold">
                            {summary.service_version.version ? (<>
                                <span className="pb-0.5 text-[20px]">v</span>
                                {summary.service_version.version}
                            </>) : "-"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgentSummary; 